module.exports = __webpack_public_path__ + "static/media/send.26d8147b.svg";